module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-15.b6422944.jpg";